import {RoutingService} from '@app/service/routing/routing.service';
// https://rnfirebase.io/docs/v3.1.*/auth/reference/auth#signInWithEmailAndPassword
export type LoginErrorCode =
  | 'auth/invalid-email'
  | 'auth/user-disabled'
  | 'auth/user-not-found'
  | 'auth/wrong-password';

// TODO: Could not find documentation on firebase logout error codes, should
// investigate this further.
export type LogoutErrorCode = 'auth/no-current-user' | string;

export type PasswordResetInitializeErrorCode =
  | 'auth/invalid-email'
  | 'auth/user-not-found';

// TODO: Doc link
export type PasswordResetErrorCode =
  | 'auth/expired-action-code'
  | 'auth/invalid-action-code'
  | 'auth/user-disabled'
  | 'auth/user-not-found'
  | 'auth/week-password';

// https://rnfirebase.io/docs/v3.1.*/auth/reference/auth#createUserWithEmailAndPassword
// TODO: What happens if I create a user with an existing email? What error?
export type CreateUserErrorCode =
  | 'auth/invalid-email'
  | 'auth/user-disabled'
  | 'auth/user-not-found'
  | 'auth/wrong-password';

// TODO: Doc link
export type PendingVerificationErrorCode =
  | 'auth/expired-action-code'
  | 'auth/invalid-action-code'
  | 'auth/user-disabled'
  | 'auth/user-not-found';

// https://rnfirebase.io/docs/v3.1.*/auth/reference/auth#checkActionCode
export type CheckingVerificationErrorCode =
  | 'auth/expired-action-code'
  | 'auth/invalid-action-code'
  | 'auth/user-disabled'
  | 'auth/user-not-disabled';

export interface AuthErrorMessage {
  message: string;
  showMessage: boolean;
  action?: any;
}

// Firebase Auth Error
export const authError = (error: any, routingService?: RoutingService): AuthErrorMessage => {
  if (error && (error.message === 'silent' || (error.message && error.message.includes('insufficient permissions')))) {
    return {
      message: null,
      showMessage: false
    };
  }
  let message: string;
  const showMessage = true;
  let action;
  const auth = {
    'email-already-in-use': 'Looks like you\'ve already registered. Click here to login!',
    'user-not-found': `Either the password is incorrect or your account does not exist!`,
    'wrong-password': `Either the password is incorrect or your account does not exist!`,
    'account-exists-diff-creds': `You have signed up previously with a different service. Use that service instead.`,
    'too-many-requests': 'Too many failed attempts made. Reset your password or please try again later.'
  };
  if (error.code === 'auth/email-already-in-use') {
    message = auth['email-already-in-use'];
    action = () => {
      if (routingService)
        return routingService.navigateLogin();
    };
  } else if (error.code === 'auth/user-not-found') {
    message = auth['user-not-found'];
    action = () => {
      if (routingService)
        return routingService.navigateRegister();
    };
  } else if (error.code === 'auth/wrong-password') {
    message = auth['wrong-password'];
  } else if (error.code === 'auth/account-exists-with-different-credential') {
    message = auth['account-exists-diff-creds'];
  } else if (error.code === 'auth/too-many-requests') {
    message = auth['too-many-requests'];
  } else {
    message = error.message || 'Oops, error!';
  }
  return {
    message,
    showMessage,
    action
  };
};

export interface ProviderData {
  displayName?: string;
  email?: string;
  phoneNumber?: string;
  photoURL?: string;
  providerId?: string;
  uid?: string;
}
